import { Navigate, Outlet } from 'react-router-dom';

export default function PrivateRoutes() {
    const token = localStorage.getItem("token") || false;
    return token !== false ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />
}